module.exports = __webpack_public_path__ + "static/media/RomanSerif-Oblique-01.558d7dcf.svg";